/**
 * @module constants
 */

export default {
  NONE: 'NONE',
  HTML: 'HTML',
  ACTIVEX: 'ACTIVEX'
};



// WEBPACK FOOTER //
// ./app/constants/containerType.js